import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import styles from "./styles.less";

const NoResults = ({
  NoResultsTitle,
  NoResultsMessage,
  phoneTitle,
  phoneNumber,
  emailTitle,
  emailAddress,
  isRtl
}) => {
  return (
    <div
      className={cx(styles.noResultsPage, styles.compactTop, {
        [styles.rtl]: isRtl
      })}
    >
      {NoResultsTitle && (
        <div className={styles.title}>{`${NoResultsTitle}`}</div>
      )}
      {NoResultsMessage && (
        <div className={styles.message}>{`${NoResultsMessage}`}</div>
      )}
      <div className={styles.contactInfo}>
        {phoneNumber && (
          <div className={styles.infoGroup}>
            <span className={styles.infoField}>{phoneTitle} - </span>
            <a href={`tel:${phoneNumber}`} className={styles.infoField}>
              {phoneNumber}
            </a>
          </div>
        )}
        {emailAddress && (
          <div className={styles.infoGroup}>
            <span className={styles.infoField}>{emailTitle} - </span>
            <a href={`mailto:${emailAddress}`} className={styles.infoField}>
              {emailAddress}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

NoResults.defaultProps = {
  isRtl: false,
  phoneTitle: "Phone",
  emailTitle: "E-Mail"
};

NoResults.propTypes = {
  isRtl: PropTypes.bool,
  NoResultsTitle: PropTypes.string,
  NoResultsMessage: PropTypes.string,
  phoneTitle: PropTypes.string,
  phoneNumber: PropTypes.string,
  emailTitle: PropTypes.string,
  emailAddress: PropTypes.string
};

export default NoResults;



// WEBPACK FOOTER //
// ./src/components/common/NoResults/NoResults.js